/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DatasourceConfigBase } from './DatasourceConfigBase';
import { DatasourceConfigBaseFromJSON, DatasourceConfigBaseFromJSONTyped, DatasourceConfigBaseToJSON, } from './DatasourceConfigBase';
import type { DatasourcePurpose } from './DatasourcePurpose';
import { DatasourcePurposeFromJSON, DatasourcePurposeFromJSONTyped, DatasourcePurposeToJSON, } from './DatasourcePurpose';
/*
causes circular dependendies
// .concat(DatasourceConfigBaseValidator)

*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DatasourceConfigGCS
 *
 */
// create custom validators for the regexes
export interface DatasourceConfigGCS extends DatasourceConfigBase {
    /**
     * path includes the bucket name and the path within the bucket where you have stored your information
     * #type string
     * #memberof DatasourceConfigGCS
        
        
         */
    fullPath: string;
    /**
     * The projectId where you have your bucket configured
     * #type string
     * #memberof DatasourceConfigGCS
        
        
    * @minLength 1
         */
    gcsProjectId: string;
    /**
     * this is the content of the credentials JSON file stringified which you downloaded from Google Cloud Platform
     * #type string
     * #memberof DatasourceConfigGCS
        
        
         */
    gcsCredentials: string;
}
/**
 * Check if a given object implements the DatasourceConfigGCS interface.
 */
export function instanceOfDatasourceConfigGCS(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fullPath" in value;
    isInstance = isInstance && "gcsProjectId" in value;
    isInstance = isInstance && "gcsCredentials" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DatasourceConfigBaseValidator, DatasourceConfigBaseStringifyShape, DatasourceConfigBaseStringifyShapeProperties, } from './DatasourceConfigBase';
import { DatasourcePurposeValidator, DatasourcePurposeStringifyShape, DatasourcePurposeStringifyShapeProperties, } from './DatasourcePurpose';
export const DatasourceConfigGCSTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasourceConfigGCS => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasourceConfigGCS => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && "string" === typeof input.type && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fullPath", "gcsProjectId", "gcsCredentials", "id", "purpose", "type", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceConfigGCS => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.gcsProjectId && (1 <= input.gcsProjectId.length || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string (@minLength 1)",
                    value: input.gcsProjectId
                })) || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string",
                    value: input.gcsProjectId
                })) && ("string" === typeof input.gcsCredentials || $guard(_exceptionable, {
                    path: _path + ".gcsCredentials",
                    expected: "string",
                    value: input.gcsCredentials
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fullPath", "gcsProjectId", "gcsCredentials", "id", "purpose", "type", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigGCS",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigGCS",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasourceConfigGCSTypiaAssertStringify = (input: DatasourceConfigGCS): string => {
    return ((input: any): string => { const assert = (input: any): DatasourceConfigGCS => {
        const __is = (input: any): input is DatasourceConfigGCS => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && "string" === typeof input.type && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceConfigGCS => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.gcsProjectId && (1 <= input.gcsProjectId.length || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string (@minLength 1)",
                    value: input.gcsProjectId
                })) || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string",
                    value: input.gcsProjectId
                })) && ("string" === typeof input.gcsCredentials || $guard(_exceptionable, {
                    path: _path + ".gcsCredentials",
                    expected: "string",
                    value: input.gcsCredentials
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigGCS",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceConfigGCS",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasourceConfigGCS): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"fullPath":${$string(input.fullPath)},"gcsProjectId":${$string(input.gcsProjectId)},"gcsCredentials":${$string(input.gcsCredentials)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()},"type":${$string(input.type)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DatasourceConfigGCSValidatorShape = {
    'fullPath': yup.string().defined().test('is-valid', 'the path needs to be set', (value) => {
        if (!value) {
            return false;
        }
        return true;
    })
        .test('is-valid', "It's not allowed to use '.lightly' in your path as its a reserved word used internally", (value) => {
        if (!value) {
            return true;
        }
        if (value.startsWith('.lightly/') ||
            value.endsWith('/.lightly') ||
            value.indexOf('/.lightly/') !== -1) {
            return false;
        }
        return true;
    })
        .test('is-valid', 'The path should not directly point to the location of the .lightly folder itself but to the .lightly folders parent', (value) => {
        if (!value) {
            return true;
        }
        if (value.endsWith('/.lightly/') || value.endsWith('/.lightly')) {
            return false;
        }
        return true;
    }),
    'gcsProjectId': yup.string().min(1).defined(),
    'gcsCredentials': yup.string().defined(),
};
export const DatasourceConfigGCSValidator = yup.object().shape(DatasourceConfigGCSValidatorShape).concat(DatasourceConfigBaseValidator);
export const DatasourceConfigGCSStringifyShapeProperties: ObjectSchema['properties'] = {
    'fullPath': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'gcsProjectId': {
        'type': 'string',
        'minLength': 1,
    } as unknown as fastJSON.StringSchema,
    'gcsCredentials': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const DatasourceConfigGCSStringifyShape: ObjectSchema = {
    title: 'DatasourceConfigGCS Stringifier',
    type: 'object',
    properties: {
        ...DatasourceConfigBaseStringifyShapeProperties,
        ...DatasourceConfigGCSStringifyShapeProperties
    },
    required: [
        ...(DatasourceConfigBaseStringifyShape.required ? DatasourceConfigBaseStringifyShape.required : []),
        'fullPath',
        'gcsProjectId',
        'gcsCredentials',
    ],
};
export const DatasourceConfigGCSStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourceConfigGCSStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasourceConfigGCSStringify: (data: DatasourceConfigGCS) => string = DatasourceConfigGCSStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasourceConfigGCSFromJSON(json: any): DatasourceConfigGCS {
    return DatasourceConfigGCSFromJSONTyped(json, false);
}
export function DatasourceConfigGCSFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourceConfigGCS {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
    if (!ignoreDiscriminator) {
    }
*/
    return {
        ...DatasourceConfigBaseFromJSONTyped(json, ignoreDiscriminator),
        'fullPath': json['fullPath'],
        'gcsProjectId': json['gcsProjectId'],
        'gcsCredentials': json['gcsCredentials'],
    };
}
export function DatasourceConfigGCSToJSON(value?: DatasourceConfigGCS | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatasourceConfigBaseToJSON(value),
        'fullPath': value.fullPath,
        'gcsProjectId': value.gcsProjectId,
        'gcsCredentials': value.gcsCredentials,
    };
}
